import { MAINTENANCE } from '@/constants/maintenance';

/**
 * Centralized error and guidance messages for the app.
 *
 * @overview
 * Keep all shared user-facing error copy in one place to ensure consistent UX
 * across contexts (inquiry form, chat, etc.).
 */
export const ERROR_MESSAGES = {
  ATTACHMENTS: {
    LIMIT_EXCEEDED: {
      INQUIRY_FORM:
        'You can submit your inquiry now and add additional attachments later in the chat.',
      CHAT: 'You can send your message now and add additional attachments later.',
    },
    UPLOAD_FAILED: {
      INQUIRY_FORM:
        'You can submit your inquiry now and add additional attachments later in the chat.',
      CHAT: 'You can send your message now and add additional attachments later.',
    },
  },
  INQUIRY: {
    PHARMA_NOT_AUTHORIZED: {
      title: 'Unable to submit inquiry',
      message: 'Your account is not authorized to submit inquiries.',
    },
    MAINTENANCE_MODE: MAINTENANCE.INQUIRY_TOAST,
  },
  MESSAGES: {
    MAINTENANCE_MODE: MAINTENANCE.MESSAGES_TOAST,
  },
} as const;
export type AttachmentContext = 'inquiry_form' | 'chat';
